<template lang="pug">
    div.banner-leaderboard( :class="{ 'banner-leaderboard--lock' : lock, 'banner-leaderboard--float' : float }" )
        v-container.banner-leaderboard__container( :class="{ 'blue-grey' : !float, 'darken-2' : !float } " fluid )
            v-row( no-gutters )
                v-col( cols="12" align="center" )
                    v-img( src="@/assets/temp-ad-leaderboard.png" width="720" min-width="720" center )
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "BannerLeaderboard",
        props: {
            // fixed: Boolean
            float: Boolean
        },
        // data() {
        //     return {
        //         lock: false
        //     }
        // },
        // watch: {
        //     scroll() {

        //     }
        // },
        computed: {
            ...mapGetters([
                'scroll',
                'scrollPos'
            ]),
            lock() {
                return this.scrollPos >= 300;
            }
        },
        // mounted() {
        //     this.scroll();
        // },
        // methods: {
        //     scroll() {
                
        //     }
        // }
    }
</script>

<style scoped lang="scss">
    
    $module: 'banner-leaderboard';
    $module-height: 114px;

    .#{$module} {
        
        // &--fixed {
            padding-bottom: $module-height;
        // }

        &__container {
            position: fixed;
            height: $module-height;
            z-index: 12;

            .#{$module}--lock & {
                position: absolute;
                top: 408px;
            }

            .#{$module}--float & {
                left: 0;
                bottom: 10px;
            }
        }
    }
</style>